import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

export const mainGetLiveStock = createAsyncThunk(
  "MAIN_GET_LIVESTOCK",
  async (type = "industrial") => {
    const axiosInstance = axios.create();
    axiosInstance.defaults.headers.common = {};

    const baseUrl = `https://habackend.rasadyar.com/LiveStock/rancher/bazrasi-rancher-view`;
    const normalizedType = type ?? "industrial";
    const apiUrl = `${baseUrl}?type=${encodeURIComponent(normalizedType)}`;

    try {
      const response = await axiosInstance.get(apiUrl);
      const { data, status } = response;
      return { data, status };
    } catch (error) {
      console.error("Error fetching data:", error);
      throw error;
    }
  }
);
